import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';

const LeaveReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    leave_type: "ALL",
    leave_status: "2", // Approved by default
    action_type: "Fetch",
  });

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch Leave Types
  // ✅ Fetch Leave Types safely for any structure
// ✅ Fetch Leave Types (matches your API structure)
const fetchLeaveTypes = async () => {
  try {
    const res = await axios.get(API_BASE_URL + "/leave_types", {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

    // safely access nested structure
    const data = res.data?.data?.leave_type || [];

    if (!Array.isArray(data)) {
      toast.error("Invalid response format from /leave_type");
      setLeaveTypes([]);
      return;
    }

    setLeaveTypes(data);
  } catch (err) {
    console.error(err);
    toast.error("Failed to load leave types");
    setLeaveTypes([]);
  }
};



  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  // ✅ Fetch Report
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/leave_report",
        {
          start_date: filters.start_date,
          end_date: filters.end_date,
          leave_type: filters.leave_type,
          leave_status: filters.leave_status,
          action_type: filters.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching leave report");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Search + Pagination Logic
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.leave_type}${item.from_date}${item.to_date}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        {/* 🔹 Filter Form */}
        <div className="card shadow-sm mb-4">
          <div className="card-header with-elements">
            <span className="card-header-title me-2">Leave Report</span>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* From Date */}
                <div className="col-md-2">
                  <label htmlFor="start_date">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    value={filters.start_date}
                    onChange={handleInput}
                    required
                  />
                </div>

                {/* To Date */}
                <div className="col-md-2">
                  <label htmlFor="end_date">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={filters.end_date}
                    onChange={handleInput}
                    required
                  />
                </div>

                {/* Leave Type */}
              <div className="col-md-2">
  <label htmlFor="leave_type">Leave Type</label>
   <Select
    name="leave_type"
    value={
      leaveTypes
        .map((lt) => ({
          value: lt.value,
          label: lt.label,
        }))
        .find((d) => d.value === filters.leave_type) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "leave_type",
          value: selected ? selected.value : "ALL", // default same as your select
        },
      })
    }
    options={leaveTypes.map((lt) => ({
      value: lt.value,
      label: lt.label,
    }))}
    isClearable
    placeholder="All"
    className="basic-single"
  />
</div>


                {/* Leave Status */}
                <div className="col-md-2">
                  <label htmlFor="leave_status">Leave Status</label>
                  <select
                    className="form-control"
                    name="leave_status"
                    value={filters.leave_status}
                    onChange={handleInput}
                  >
                    <option value="2">Approved</option>
                    <option value="3">Rejected</option>
                  </select>
                </div>

                {/* Action */}
               

                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Get
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Table */}
        <div className="card">
          <h6 className="card-header text-danger">Employee Leave Report</h6>
          <div className="card-body">
            {/* Top Controls */}
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div
                className="d-flex align-items-center gap-2"
                style={{ width: "auto", minWidth: "220px" }}
              >
                <DownloadButtons data={filteredItems} filename="Leave_Report" />
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                  className="form-select form-select-sm"
                />
              </div>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "200px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Table */}
            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead      style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>Applied On</th>
                      <th>From Date</th>
                      <th>To Date</th>
                      <th>No of Days</th>
                       <th>Leave Type</th>
                      <th>Incharge</th>                   
                      <th>HOD</th>
                      <th>HR Approval</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department}</td>
                          <td>{row.applied_on}</td>
                          <td>{row.from_date}</td>
                          <td>{row.to_date}</td>
                          <td>{row.no_of_days}</td>
                          <td>{row.leave_type}</td>
                          <td>{row.incharge_name}</td>
                          
                          <td>{row.hod_name}</td>
                          
                          <td>{row.hr_approval}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="11" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveReport;
